import type { ReactNode } from "react";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { useRedirectGuard } from "web_myplann/Shared/Hooks/useRedirectGuard";

type Props = {
	title: string;
	children: ReactNode;
};

export const PortfolioAddLayout = ({ title, children }: Props) => {
	const hasPortfolioRight = usePortfolioRightOptional();
	useRedirectGuard(!hasPortfolioRight, Routing.Portfolio.PortfolioList.path());

	return (
		<MyPlannLayout
			disableContentPadding
			topBar={
				<NavigationHeader
					title={title}
					defaultRoute={Routing.Portfolio.PortfolioAddItem}
				/>
			}
		>
			{children}
		</MyPlannLayout>
	);
};
